import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import OurClientForm from "./OurClientForm";

export default function ViewOurClient({ name }) {
    return (
        <CustomCard title={name}>
            <OurClientForm type="VIEW" />
        </CustomCard>
    );
}
